<template>
  <v-dialog
      v-model="visible"
      :persistent="!consent.decided"
      max-width="620"
  >
    <v-card>
      <v-card-title class="d-flex align-center">
        <i class="fa-solid fa-shield-halved mr-3"/>
        Datenschutz-Einstellungen
      </v-card-title>

      <v-card-text>
        Wir verwenden technisch notwendige Cookies und Speicherzugriffe für Anmeldung,
        Sicherheit und ausdrücklich angeforderte Funktionen. Mit Ihrer Einwilligung
        speichern wir zusätzlich den Stand von Konfiguration und Preisberechnung auf
        Ihrem Gerät.
      </v-card-text>

      <v-list>
        <v-list-item>
          <v-list-item-title>Technisch notwendig</v-list-item-title>
          <v-list-item-subtitle>
            Anmeldung, Sicherheitsfunktionen und Speicherung Ihrer Entscheidung
          </v-list-item-subtitle>
          <template v-slot:append>
            <v-switch :model-value="true" disabled color="success" hide-details/>
          </template>
        </v-list-item>

        <v-list-item>
          <v-list-item-title>Komfortspeicher</v-list-item-title>
          <v-list-item-subtitle>
            Speichert Konfiguration und Berechnungsstand für einen späteren Besuch
          </v-list-item-subtitle>
          <template v-slot:append>
            <v-switch v-model="preferences" color="primary" hide-details/>
          </template>
        </v-list-item>
      </v-list>

      <v-card-actions class="flex-wrap">
        <v-btn variant="outlined" @click="save(false)">
          Nur notwendige
        </v-btn>
        <v-spacer/>
        <v-btn color="primary" @click="save(preferences)">
          Auswahl speichern
        </v-btn>
        <v-btn color="primary" @click="save(true)">
          Alle akzeptieren
        </v-btn>
      </v-card-actions>

      <v-card-text class="pt-0 text-caption">
        Details finden Sie in unserer
        <router-link to="/info" @click="visible = false">Datenschutzerklärung</router-link>.
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import {getConsent, saveConsent} from '@/services/consentStorage'

export default {
  name: 'CookieConsent',

  data() {
    const consent = getConsent()

    return {
      visible: !consent.decided,
      preferences: consent.preferences,
      consent
    }
  },

  methods: {
    save(preferences) {
      this.consent = saveConsent(preferences)
      this.preferences = this.consent.preferences
      this.visible = false
    },
    openSettings() {
      this.consent = getConsent()
      this.preferences = this.consent.preferences
      this.visible = true
    }
  },

  mounted() {
    window.addEventListener('myservices-open-consent-settings', this.openSettings)
  },

  beforeUnmount() {
    window.removeEventListener('myservices-open-consent-settings', this.openSettings)
  }
}
</script>
